import React from "react";
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { useStyles } from "./styles";
const PickerModHora = (props) => {
  const {
    id = "date-picker-inline",
    label = "Date picker",
    formatFecha = "dd/MM/yyyy HH:mm",
    selectedDate = new Date(),
    setSelectedDate = () => { },
    disablePast = true,
    disableFuture = false,
    disableToolbar = true,
    disabled = false,
    variant = "inline",
    className = ""
  } = props;
  const classes = useStyles();
  const handleDateChange = (date) => {
    setSelectedDate(date);
  }
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
      <KeyboardDateTimePicker
        disabled={disabled}
        disablePast={disablePast}
        disableFuture={disableFuture}
        className={`${classes.margin} ${className}`}
        disableToolbar={disableToolbar}
        variant={variant}
        inputVariant="outlined"
        format={formatFecha}
        id={id}
        label={label}
        placeholder="dd/mm/yyyy hh:mm"
        value={selectedDate}
        ampm={false}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          "aria-label": label,
        }}
      />
    </MuiPickersUtilsProvider>
  );
};
export default PickerModHora;
